
import Component, { mixins } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { SchemeScope } from '@/components/mixins/schemescope';
import { allNodes } from '@/services/scheme';
import { flatMapLeaves, filterTree, getNodeIdsFromTree, isSkill } from '@/services/utils';

@Component
export default class AdditionalAssessments extends mixins(SchemeScope) {
  @Prop() private inProgressLevels!: string[];

  get additionalSkillNodes() {
    const tree = this.schemeAssessibleNodes;

    // Using a local to avoid calling the getter many times in a tight loop, causes ~20x speedup on my machine for BG curriculum.
    const inProgressSkills = this.inProgressSkills;
    const nodes = allNodes(tree).filter(node => !inProgressSkills.includes(node.id) && !node.skill);
    nodes.forEach((node: any) => {
      let name = node.name;
      if (node.parentId && node.parentId !== '/') {
        const parentNode = this.getNode(node.parentId);
        name = `${parentNode.title} - ${node.name}`;
      }
      node.name = name;
    });
    return nodes;
  }

  get inProgressSkills() {
    if (this.inProgressLevels.length === 0) {
      return [];
    }
    // Now get the children of all leaves of the tree (the lowest levels)
    // (NOTE: not worth copying inProgressLevels to a local here)
    return flatMapLeaves(
      filterTree(this.schemeAssessibleNodes, n => this.inProgressLevels.includes(n.id)),
      n => getNodeIdsFromTree(this.getNode(n.id))
    )
      .flat()
      .filter(node => !isSkill(node));
  }

  get additionalAssessmentNodeIds() {
    return this.$store.getters['schemes/additionalAssessmentNodeIds'](this.slug);
  }

  set additionalAssessmentNodeIds(nodeIds: Array<string>) {
    this.$store.dispatch('schemes/updateAdditionalAssessmentNodeIds', { slug: this.slug, nodeIds });
  }
}
